var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, memo, useContext } from 'react';
export const CreatorDaresContext = createContext(null);
export const useCreatorDaresContext = () => {
    const context = useContext(CreatorDaresContext);
    if (!context) {
        throw new Error('useCreatorDaresContext must be used within a CreatorDaresProvider');
    }
    return context;
};
export const CreatorDaresProvider = memo((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (<CreatorDaresContext.Provider value={props}>
			{children}
		</CreatorDaresContext.Provider>);
});
